import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Image from 'next/legacy/image';
import BedChallengeImg from '../../assets/bedChallenge2021/key.jpg';
import { LinkSecondaryButton } from '../../components/actions/link-button';
import { Meta } from '../../components/meta/meta';
import style from './styles/bed-challenge.module.css';

export default function Home() {
  return (
    <main className="relative flex flex-col text-white">
      <Meta title="Bed Challenge 2021" description="Beds for Kids 2021 Bed Challenge Home Page" />
      {/* Top Section */}
      <section className="flex bg-green-500">
        <div className="container mx-auto flex flex-row flex-wrap items-center justify-center md:px-4">
          <div className="order-2 m-4 flex w-full flex-col justify-center px-4 md:order-1 md:m-0 md:w-1/2 md:px-0">
            <h2 className="after:content=[''] m-0 mr-4 font-[Bicyclette] text-3xl after:my-3 after:block after:h-[6px] after:max-w-[125px] after:bg-blue-500">
              Thank you for helping us put 2021 to bed and give 2,021 beds to children in need
            </h2>
          </div>
          <div className="relative order-1 w-screen md:w-1/2">
            <Image priority layout="responsive" src={BedChallengeImg} alt="2021 Bed Challenge" placeholder={'blur'} />
          </div>
        </div>
      </section>
      <section className="flex bg-blue-500">
        <div className="container mx-auto flex flex-row flex-wrap justify-center md:px-4">
          <h1 className="my-8 w-full text-center font-[Bicyclette] text-3xl uppercase md:text-5xl">
            2021 Bed Challenge Totals
          </h1>
          <div className={style.cont}>
            <span className={style.figure}>$346,116</span>
            <span className={style.desc}>donated</span>
            <ChevronRightIcon className={style.chevron} />
          </div>
          <div className={style.cont}>
            <span className={style.figure}>2307</span>
            <span className={style.desc}>beds donated</span>
            <ChevronRightIcon className={style.chevron} />
          </div>
          <div className={`${style.cont} ${style.noBorder}`}>
            <span className={style.figure}>114%</span>
            <span className={style.desc}>of fundraising goal</span>
          </div>
          <div className="my-8">
            <LinkSecondaryButton
              href="/donate"
              className="umami--click--home-page-donate-today uppercase-4 font-[Bicyclette]">
              Donate Today
            </LinkSecondaryButton>
          </div>
        </div>
      </section>
    </main>
  );
}
